import React, { useEffect, useState } from "react";
import "../Css/BlogCardDetailPage.css";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Divider, Empty, Spin } from "antd";
import { NavLink, useParams } from "react-router-dom";
import { get } from "../apiService";
import moment from "moment";
import BannerComp from "../Components/BannerComp";
import blogBanner from "../Assets/ProductImages/Product Melee/1.jpg";

const BlogCardDetailPage = () => {
  const [loading, setLoading] = useState(false);
  const [getData, setGetData] = useState(null);
  const [blogList, setBlogList] = useState([]);

  const { slug } = useParams();
  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchExibitionDetail();
    }, 300);

    return () => clearTimeout(dbounce);
    // eslint-disable-next-line
  }, []);

  const fetchExibitionDetail = async () => {
    setLoading(true);
    try {
      const response = await get(`/exibition.php?action=fetch&slug=${slug}`);
      if (response) {
        setGetData(response.list[0]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(1, 10);
    }, 300);

    return () => clearTimeout(dbounce);
    // eslint-disable-next-line
  }, []);

  const fetchData = async (current, pageSize) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/exibition.php?limit=${pageSize}&page=${current}&type=blog&action=${action}`
      );
      const filterData = response?.list.filter((val) => val.slug !== slug);
      setBlogList(filterData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <BannerComp
        title={getData?.title}
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Blog",
            href: "/best-diamond-supplier",
          },
          {
            title: getData?.title,
          },
        ]}
        image={blogBanner}
      />
      <Spin spinning={loading}>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div>
                  <h2 className="pt-4 fw-bold">{getData?.title}</h2>
                  <div className="d-flex justify-content-between align-items-center ">
                    <span className="">
                      <label>
                        <label>
                          {moment(getData?.created_at).format("MMMM DD, YYYY")}
                        </label>
                      </label>
                    </span>
                  </div>
                  <div>
                    <img
                      src={getData?.image || `/blog-image/${getData?.slug}.webp`}
                      className="blogCard-img"
                      alt="Exibition details page"
                      onError={(e) => {
                        e.target.onerror = null; // Prevents infinite loop in case the demo image also fails
                        e.target.src = "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?q=80&w=1000&auto=format&fit=crop"; // Provide the path to your demo image
                      }}
                    />
                    <div
                      className="BlogCardDetailPage-para pt-3"
                      dangerouslySetInnerHTML={{ __html: getData?.description }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="BlogCardDetailPage-grid-right-icon-sticky">
                  <div className="mt-5 BlogCardDetailPage-grid-right-icon">
                    <div>
                      <span className="fw-light py-3">More Blogs</span>
                      <Divider />
                      {blogList.length > 0 ? (
                        blogList.map((val, index) => (
                          <NavLink
                            to={`/view/${val.slug}`}
                            className="more-post mb-3"
                            key={index}
                          >
                            <img 
                              src={val.image || `/blog-image/${val.slug}.webp`} 
                              alt={val.title}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?q=80&w=1000&auto=format&fit=crop";
                              }}
                            />
                            <div className="more-post-text">
                              <h5>{val.title}</h5>
                              <span>
                                {moment(val.date).format("MMMM DD YYYY")}
                              </span>
                            </div>
                          </NavLink>
                        ))
                      ) : (
                        <Empty />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Spin>

      <Footer />
    </>
  );
};

export default BlogCardDetailPage;
